export default {
  profile: (): Promise<IResponse<Object>> => {
    return window.apis.profile();
  }
};
